import React, { useEffect, useState } from "react";
import { Trash, Plus, Shield } from "@phosphor-icons/react";
import { api } from "../../lib/api";
import { useAuth } from "../../lib/auth";
import { toast } from "sonner";

export default function AdminUsers() {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("admin");

  const load = () => api.get("/admin/users").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/users", { email, role });
      toast.success("Admin added — they can now sign in with Google");
      setEmail("");
      load();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed");
    }
  };

  const del = async (em) => {
    if (!window.confirm(`Remove ${em} from admins?`)) return;
    try {
      await api.delete(`/admin/users/${encodeURIComponent(em)}`);
      toast.success("Removed");
      load();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed");
    }
  };

  return (
    <div className="p-8 md:p-10" data-testid="admin-users">
      <div className="mb-8">
        <div className="overline mb-2">Access</div>
        <h1 className="font-display text-5xl uppercase text-white leading-none">Admin Users</h1>
        <p className="text-white/60 mt-2 text-sm">Only emails listed here can sign in to the admin dashboard.</p>
      </div>

      <form onSubmit={add} className="admin-card mb-6 flex flex-col md:flex-row gap-3 md:items-end" data-testid="add-admin-form">
        <div className="flex-1">
          <div className="admin-label">Google account email</div>
          <input required type="email" className="admin-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@example.com" data-testid="new-admin-email" />
        </div>
        <div className="md:w-48">
          <div className="admin-label">Role</div>
          <select className="admin-input" value={role} onChange={(e) => setRole(e.target.value)} data-testid="new-admin-role">
            <option value="admin">Admin</option>
            <option value="superadmin">Superadmin</option>
          </select>
        </div>
        <button type="submit" className="btn-primary" data-testid="add-admin-btn"><Plus size={18} weight="bold" /> Add</button>
      </form>

      <div className="admin-card p-0">
        <ul className="divide-y divide-[#2a2a2a]">
          {list.map((a) => (
            <li key={a.email} className="p-5 flex items-center justify-between gap-4" data-testid={`admin-row-${a.email}`}>
              <div className="flex items-center gap-3 min-w-0">
                <div className="h-10 w-10 bg-atc-red text-white flex items-center justify-center font-display text-lg shrink-0">{a.email[0].toUpperCase()}</div>
                <div className="min-w-0">
                  <div className="font-heading uppercase text-white truncate">{a.email}</div>
                  <div className="flex items-center gap-2 font-mono text-[10px] text-white/40 uppercase tracking-widest mt-1">
                    <Shield size={10} weight="bold" /> {a.role}
                    {a.email === user?.email && <span className="text-atc-red">· you</span>}
                  </div>
                </div>
              </div>
              {a.email !== "media@atcpestcontrol.com" && a.email !== user?.email && (
                <button onClick={() => del(a.email)} className="border border-[#333] hover:border-atc-red p-2 shrink-0" data-testid={`delete-admin-${a.email}`}>
                  <Trash size={14} weight="bold" />
                </button>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
